import {connect} from 'react-redux';
import {createStructuredSelector} from 'reselect';

import {userId} from '/redux/selector/currentUser.selector';
import {
  allCandidatesCountById,
  referralsCountById,
} from '/redux/selector/metric.clients.selector';
import {withProps} from '/util/selector.util';

import CandidatesSection from './CandidatesSection';

const withCoachUserId = withProps({coachId: userId});
export default connect(
  createStructuredSelector({
    allCandidatesCount: withCoachUserId(allCandidatesCountById),
    referralsCount: withCoachUserId(referralsCountById),
  }),
)(CandidatesSection);
